export const colors = {
  primary: '#0A5953',
  primaryHover: '#084542',
  secondary: '#2F8A71',
  accent: '#B1D4D1',
  background: '#F8FDFD',
  white: '#FFFFFF',
  text: {
    primary: '#333333',
    secondary: '#555555',
    placeholder: '#999999',
    error: '#dc3545'
  },
  border: '#DDDDDD'
}; 